// extracted by mini-css-extract-plugin
export default {"listReset":"list-reset_listReset__oUnYG"};